import Header from '../Header/Header';
import QuizTopic from '../QuizTopic/QuizTopic';



const Home = () => {
    return (
        <div>
            <Header/>
            <QuizTopic/>
        </div>
    );
};

export default Home;